import { api } from "@/lib/api";
import { createGoBackRequest } from "@/lib/appointment-go-back";
import type { uuid } from "@/interfaces";
import { toAppointmentJoin } from "@/repositories/appointment-records";
import { activeOrganization, type AppointmentJoin } from "@/repositories/appointments.repository";

const requestGoBack = createGoBackRequest(api.appointments);

export async function sendBack(id: uuid, date: string, reasons?: string): Promise<AppointmentJoin> {
  return toAppointmentJoin(await requestGoBack(id, { date, reasons, actingOrganization: activeOrganization() }));
}
